{
  "verified": "2026-09-13",
  "url": "https://www.bls.gov/news.release/conemp.htm",
  "sha256": "9e9f5a587821fc9bc870fb456fc10beed5b41629e13e7da81dacceae640029f3",
  "rows": [
    {
      "group": "summary",
      "label": "Total, 16 years and over",
      "total": 161878,
      "count": 11904,
      "rate": 7.4
    },
    {
      "group": "occupation",
      "label": "Management, professional, and related occupations",
      "total": 71164,
      "count": 5303,
      "rate": 7.5
    },
    {
      "group": "occupation",
      "label": "Management, business, and financial operations occupations",
      "total": 31154,
      "count": 2993,
      "rate": 9.6
    },
    {
      "group": "occupation",
      "label": "Management occupations",
      "total": 20824,
      "count": 2239,
      "rate": 10.8
    },
    {
      "group": "occupation",
      "label": "Business and financial operations occupations",
      "total": 10330,
      "count": 754,
      "rate": 7.3
    },
    {
      "group": "occupation",
      "label": "Professional and related occupations",
      "total": 40010,
      "count": 2310,
      "rate": 5.8
    },
    {
      "group": "occupation",
      "label": "Computer and mathematical occupations",
      "total": 6694,
      "count": 203,
      "rate": 3
    },
    {
      "group": "occupation",
      "label": "Architecture and engineering occupations",
      "total": 3862,
      "count": 170,
      "rate": 4.4
    },
    {
      "group": "occupation",
      "label": "Life, physical, and social science occupations",
      "total": 1985,
      "count": 122,
      "rate": 6.1
    },
    {
      "group": "occupation",
      "label": "Community and social services occupations",
      "total": 3120,
      "count": 167,
      "rate": 5.4
    },
    {
      "group": "occupation",
      "label": "Legal occupations",
      "total": 2209,
      "count": 182,
      "rate": 8.3
    },
    {
      "group": "occupation",
      "label": "Education, training, and library occupations",
      "total": 8557,
      "count": 159,
      "rate": 1.9
    },
    {
      "group": "occupation",
      "label": "Arts, design, entertainment, sports, and media occupations",
      "total": 3563,
      "count": 1001,
      "rate": 28.1
    },
    {
      "group": "occupation",
      "label": "Healthcare practitioners and technical occupations",
      "total": 10019,
      "count": 306,
      "rate": 3.1
    },
    {
      "group": "occupation",
      "label": "Service occupations",
      "total": 26264,
      "count": 1901,
      "rate": 7.2
    },
    {
      "group": "occupation",
      "label": "Healthcare support occupations",
      "total": 4911,
      "count": 164,
      "rate": 3.3
    },
    {
      "group": "occupation",
      "label": "Protective service occupations",
      "total": 3179,
      "count": 30,
      "rate": 0.9
    },
    {
      "group": "occupation",
      "label": "Food preparation and serving related occupations",
      "total": 8144,
      "count": 104,
      "rate": 1.3
    },
    {
      "group": "occupation",
      "label": "Building and grounds cleaning and maintenance occupations",
      "total": 5747,
      "count": 761,
      "rate": 13.2
    },
    {
      "group": "occupation",
      "label": "Personal care and service occupations",
      "total": 4284,
      "count": 842,
      "rate": 19.7
    },
    {
      "group": "occupation",
      "label": "Sales and office occupations",
      "total": 30690,
      "count": 2060,
      "rate": 6.7
    },
    {
      "group": "occupation",
      "label": "Sales and related occupations",
      "total": 14508,
      "count": 1553,
      "rate": 10.7
    },
    {
      "group": "occupation",
      "label": "Office and administrative support occupations",
      "total": 16182,
      "count": 507,
      "rate": 3.1
    },
    {
      "group": "occupation",
      "label": "Natural resources, construction, and maintenance occupations",
      "total": 14000,
      "count": 1661,
      "rate": 11.9
    },
    {
      "group": "occupation",
      "label": "Farming, fishing, and forestry occupations",
      "total": 1078,
      "count": 60,
      "rate": 5.6
    },
    {
      "group": "occupation",
      "label": "Construction and extraction occupations",
      "total": 8038,
      "count": 1212,
      "rate": 15.1
    },
    {
      "group": "occupation",
      "label": "Installation, maintenance, and repair occupations",
      "total": 4884,
      "count": 388,
      "rate": 7.9
    },
    {
      "group": "occupation",
      "label": "Production, transportation, and material moving occupations",
      "total": 19759,
      "count": 979,
      "rate": 5
    },
    {
      "group": "occupation",
      "label": "Production occupations",
      "total": 8269,
      "count": 253,
      "rate": 3.1
    },
    {
      "group": "occupation",
      "label": "Transportation and material moving occupations",
      "total": 11490,
      "count": 725,
      "rate": 6.3
    },
    {
      "group": "industry",
      "label": "Agriculture and related industries",
      "total": 2203,
      "count": 282,
      "rate": 12.8
    },
    {
      "group": "industry",
      "label": "Nonagricultural industries",
      "total": 159567,
      "count": 11622,
      "rate": 7.3
    },
    {
      "group": "industry",
      "label": "Mining, quarrying, and oil and gas extraction",
      "total": 640,
      "count": 9,
      "rate": 1.5
    },
    {
      "group": "industry",
      "label": "Construction",
      "total": 11489,
      "count": 2121,
      "rate": 18.5
    },
    {
      "group": "industry",
      "label": "Manufacturing",
      "total": 15853,
      "count": 347,
      "rate": 2.2
    },
    {
      "group": "industry",
      "label": "Durable goods manufacturing",
      "total": 10460,
      "count": 254,
      "rate": 2.4
    },
    {
      "group": "industry",
      "label": "Nondurable goods manufacturing",
      "total": 5393,
      "count": 92,
      "rate": 1.7
    },
    {
      "group": "industry",
      "label": "Wholesale and retail trade",
      "total": 20403,
      "count": 927,
      "rate": 4.5
    },
    {
      "group": "industry",
      "label": "Wholesale trade",
      "total": 3730,
      "count": 185,
      "rate": 5
    },
    {
      "group": "industry",
      "label": "Retail trade",
      "total": 16673,
      "count": 742,
      "rate": 4.5
    },
    {
      "group": "industry",
      "label": "Transportation and utilities",
      "total": 9824,
      "count": 938,
      "rate": 9.5
    },
    {
      "group": "industry",
      "label": "Transportation and warehousing",
      "total": 8328,
      "count": 899,
      "rate": 10.8
    },
    {
      "group": "industry",
      "label": "Utilities",
      "total": 1496,
      "count": 39,
      "rate": 2.6
    },
    {
      "group": "industry",
      "label": "Information",
      "total": 2881,
      "count": 302,
      "rate": 10.5
    },
    {
      "group": "industry",
      "label": "Financial activities",
      "total": 10935,
      "count": 1185,
      "rate": 10.8
    },
    {
      "group": "industry",
      "label": "Finance and insurance",
      "total": 7712,
      "count": 405,
      "rate": 5.3
    },
    {
      "group": "industry",
      "label": "Real estate and rental and leasing",
      "total": 3224,
      "count": 780,
      "rate": 24.2
    },
    {
      "group": "industry",
      "label": "Professional and business services",
      "total": 21143,
      "count": 2864,
      "rate": 13.5
    },
    {
      "group": "industry",
      "label": "Professional and technical services",
      "total": 14217,
      "count": 1736,
      "rate": 12.2
    },
    {
      "group": "industry",
      "label": "Management, administrative, and waste services",
      "total": 6926,
      "count": 1128,
      "rate": 16.3
    },
    {
      "group": "industry",
      "label": "Education and health services",
      "total": 35727,
      "count": 1050,
      "rate": 2.9
    },
    {
      "group": "industry",
      "label": "Educational services",
      "total": 13128,
      "count": 248,
      "rate": 1.9
    },
    {
      "group": "industry",
      "label": "Health care and social assistance",
      "total": 22599,
      "count": 802,
      "rate": 3.5
    },
    {
      "group": "industry",
      "label": "Leisure and hospitality",
      "total": 14603,
      "count": 752,
      "rate": 5.1
    },
    {
      "group": "industry",
      "label": "Arts, entertainment, and recreation",
      "total": 4011,
      "count": 579,
      "rate": 14.4
    },
    {
      "group": "industry",
      "label": "Accommodation and food services",
      "total": 10592,
      "count": 173,
      "rate": 1.6
    },
    {
      "group": "industry",
      "label": "Other services",
      "total": 7634,
      "count": 1099,
      "rate": 14.4
    },
    {
      "group": "industry",
      "label": "Public administration",
      "total": 8433,
      "count": 29,
      "rate": 0.3
    }
  ]
}
